import React, {
  FormEvent,
  ReactElement,
  useEffect,
  useRef,
  useState,
} from 'react';
import './Register.scss';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import axios from 'axios';
import _ from 'lodash';
import Loading from '../loading/Loading';
import { useNavigate, Link } from 'react-router-dom';
import ExampleImg from '../../assets/images/example.png';
import ExampleImgRu from '../../assets/images/example_ru.png';
import Example from '../example/Example';
import Info from '../info/Info';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FacebookIcon, FacebookShareButton } from 'react-share';
import Et from '../info/Et';
import Ru from '../info/Ru';

import Collage from '../../assets/images/collage.png';

const Register: React.FC = (): ReactElement => {
  type GreenType = typeof ExampleImg | typeof ExampleImgRu;

  const { t } = useTranslation();

  type ValidationErrors = {
    Receiver: { state: boolean; message: string };
    Sender: { state: boolean; message: string };
    Message: { state: boolean; message: string };
    Image: { state: boolean; message: string };
    Participate: { state: boolean; message: string };
  };

  const [exampleActive, setExampleActive] = useState<boolean>(false);

  const [infoActive, setInfoActive] = useState<boolean>(false);

  const [userImage, setUserImage] = useState<string>(ExampleImg);

  const [fileName, setFileName] = useState<string>('');

  const [userData, setUserData] = useState<FormData>(new FormData());

  const [uploaded, setUploaded] = useState<boolean>(false);

  const [greenImage, setGreenImage] = useState<GreenType>(ExampleImg);

  const getLanguage = () => i18n.language || window.localStorage.i18nextLng;

  const [errors, setValidationErrors] = useState<ValidationErrors>({
    Receiver: { state: false, message: '' },
    Sender: { state: false, message: '' },
    Message: { state: false, message: '' },
    Image: { state: false, message: '' },
    Participate: { state: false, message: '' },
  });

  const [loading, setLoading] = useState<boolean>(false);

  const [showThanks, setShowThanks] = useState<boolean>(false);

  const navigate = useNavigate();

  let RuleSet = useRef(Et);

  useEffect(() => {
    setTimeout(function () {
      switch (getLanguage()) {
        case 'et':
          RuleSet.current = Et;
          setGreenImage(ExampleImg);
          break;
        case 'ru':
          RuleSet.current = Ru;
          setGreenImage(ExampleImgRu);

          break;
        default:
          RuleSet.current = Et;
          setGreenImage(ExampleImg);

          break;
      }
    }, 100);
  }, [i18n.language]);

  const getFileName = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files) return;
    setFileName(event.target.files[0].name);
  };

  const getExample = () => {
    setLoading(true);
    const myForm = document.getElementById('register-form') as HTMLFormElement;
    const formData = new FormData(myForm);
    formData.append('lang', getLanguage());

    // formData.forEach((entries) => console.log(entries));
    axios
      .post('https://soeluuring.messenger.ee/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          /*'Access-Control-Allow-Origin': 'http://localhost:3002',*/
        },
      })
      //.post('http://192.168.1.81:3002/upload', {headers: {"Access-Control-Allow-Origin": "http://192.168.1.81:3002"}})
      .then((res) => {
        // navigate('/thanks', { state: { image: res.data.img_b64 } });

        if (res.data.IsValid) {
          // console.log('valid');
          setUserImage(res.data.img_b64);
          setUserData(formData);
          // setExampleActive(true);
          setShowThanks(true);
          setLoading(false);
          // navigate('/thanks', { state: { image: res.data.img_b64 } });
        } else {
          // console.log(res.data.Errors);
          setValidationErrors({
            Receiver: { state: false, message: '' },
            Sender: { state: false, message: '' },
            Message: { state: false, message: '' },
            Image: { state: false, message: '' },
            Participate: { state: false, message: '' },
          });

          if (!_.isEmpty(res.data.Errors)) {
            const err = res.data.Errors;
            // console.log(err.code);
            setValidationErrors({
              Message: _.isEmpty(err.message)
                ? { state: false, message: '' }
                : { state: true, message: err.message[0].message },
              Image: _.isEmpty(err.image)
                ? { state: false, message: '' }
                : { state: true, message: err.image[0].message },
              Receiver: _.isEmpty(err.receiver)
                ? { state: false, message: '' }
                : { state: true, message: err.receiver[0].message },
              Sender: _.isEmpty(err.sender)
                ? { state: false, message: '' }
                : { state: true, message: err.sender[0].message },
              Participate: _.isEmpty(err.participate)
                ? { state: false, message: '' }
                : { state: true, message: err.participate[0].message },
            });
            // console.log(res.data.errors);
          }
          setLoading(false);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const submitForm = async () => {
    // event.preventDefault();
    // console.log('campaign is over');
    setLoading(true);
    const myForm = document.getElementById('register-form') as HTMLFormElement;
    const formData = new FormData(myForm);
    formData.append('lang', getLanguage());
    const response = await fetch(userImage);
    // here image is url/location of image
    const blob = await response.blob();
    const file = new File([blob], 'image.jpg', { type: blob.type });
    // const test_file = new File(userImage, 'meeldetuletus.png');
    try {
      await navigator.share({
        title: 'Meeldetuletus',
        text: 'Meeldetuletus',
        files: [file],
      });
    } catch (err) {
      console.log(err);
      // var link = document.createElement('a');
      // link.download = 'meeldetuletus'; // <- name instead of 'name'
      // link.href = userImage;
      // link.click();
      // link.remove();
    }
    // formData.forEach((entries) => console.log(entries));

    // console.log(typeof formData);

    axios
      .post('https://soeluuring.messenger.ee/save', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        // console.log(res.data);
        setLoading(false);
        if (res.data.IsValid) {
          setUploaded(true);
          setTimeout(() => {
            window.location.reload();
            myForm.reset();
            setFileName('');
            // (document.getElementById('image-input') as HTMLInputElement).value =
            //   '';

            setValidationErrors({
              Receiver: { state: false, message: '' },
              Sender: { state: false, message: '' },
              Message: { state: false, message: '' },
              Image: { state: false, message: '' },
              Participate: { state: false, message: '' },
            });
            setUploaded(false);
            setShowThanks(false);

            window.scrollTo(0, 0);
          }, 1000);
        }

        // navigate('/thanks', { state: { image: res.data.img_b64 } });
      })
      .catch(function (error) {
        setLoading(false);
        console.log(error);
      });
  };

  let CampaignOver = false;

  return (
    <section id="register" className="Register">
      <Example
        exampleModalActive={exampleActive}
        setExampleModalActive={setExampleActive}
        userImage={userImage}
        userData={userData}
      />

      {/* <Info infoModalActive={infoActive} setInfoModalActive={setInfoActive} /> */}

      <div>
        <Loading loading={loading} />
        {/* <FacebookShareButton
            url={
              'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/StDenis.jpg/1024px-StDenis.jpg'
            }
          >
            <FacebookIcon />
          </FacebookShareButton> */}
        <form
          id="register-form"
          className={showThanks || infoActive ? 'hidden' : ''}
        >
          {/* image */}
          <div className="filefield-container">
            <span className="title">{t('title')}</span>
            <div className="file">
              <label className="file-label">
                <input
                  id="image-input"
                  className="file-input"
                  type="file"
                  name="image"
                  onChange={(e) => {
                    getFileName(e);
                  }}
                />
                <span className="file-cta">
                  <p>{t('image')}</p>
                </span>
              </label>
            </div>
            <span className="file-name">{fileName}</span>
            {errors.Image.state && (
              <p className="help is-danger">
                {t('validation.' + errors.Image.message)}
              </p>
            )}
          </div>
          <div className="textbox-container">
            <div className="img-wrapper">
              <img src={greenImage} alt="" />
            </div>
            {/* receiver */}

            <div className="field-wrapper">
              <h3>{t('form title')}</h3>

              <div className="field">
                <div className="control">
                  <input
                    className="input"
                    type="text"
                    name="receiver"
                    placeholder={t('receiver')}
                  />
                </div>
                {errors.Receiver.state && (
                  <p className="help is-danger">
                    {t('validation.' + errors.Receiver.message)}
                  </p>
                )}
              </div>

              {/* message */}
              <div className="field">
                <div className="control">
                  <textarea
                    className="textarea"
                    name="message"
                    maxLength={150}
                    placeholder={t('message')}
                  ></textarea>
                </div>
                {errors.Message.state && (
                  <p className="help is-danger">
                    {t('validation.' + errors.Message.message)}
                  </p>
                )}
              </div>
              {/* sender */}
              <div className="field">
                <div className="control">
                  <input
                    className="input"
                    type="text"
                    name="sender"
                    placeholder={t('sender')}
                  />
                </div>
                {errors.Sender.state && (
                  <p className="help is-danger">
                    {t('validation.' + errors.Sender.message)}
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* <div className="preview-container">
            <button
              type="button"
              className="button"
              onClick={() => getExample()}
            >
              {t('preview')}
            </button>
          </div> */}

          <div id="next-anchor" className="next-container">
            {/* participate in next */}
            <div className="next-description">
              <p>
                <span>{t('next.description 1')} </span>
                <span>
                  {t('next.description 2')}{' '}
                  <a onClick={() => setInfoActive(true)}>{t('next.link')}</a>
                </span>
              </p>
            </div>
            <div className="field checkbox-field">
              <div className="control">
                <label className="radio">
                  <input type="radio" name="participate" value="yes" />
                  <span>{t('yes')}</span>
                </label>
                <label className="radio">
                  <input type="radio" name="participate" value="no" />
                  <span>{t('no')}</span>
                </label>
              </div>
              {errors.Participate.state && (
                <p className="help is-danger">
                  {t('validation.' + errors.Participate.message)}
                </p>
              )}
            </div>
          </div>
          <div className="submit-container">
            {/* SUBMIT BUTTON */}
            {CampaignOver ? (
              <div className="campaign-over-wrapper">
                <span className="campaign-over">{t('campaign over')}</span>
                <span className="campaign-over">{t('congratulations')}</span>
              </div>
            ) : (
              <div className="form-btn-wrapper">
                {/* <button type="submit" className="button">
                  {t('participate')}
                </button> */}
                <button
                  type="button"
                  className="button"
                  onClick={() => getExample()}
                >
                  {t('preview')}
                </button>
              </div>
            )}
          </div>
        </form>
      </div>

      <div id="info-modal" className={'info ' + (infoActive ? '' : 'hidden')}>
        {/* <div className="modal-background"></div> */}
        <button
          className="modal-close-btn"
          aria-label="close"
          onClick={() => setInfoActive(!infoActive)}
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
        <div className="modal-content">
          <div className="content-wrapper">
            <div className="columns">
              <div className="column text-col">
                <p className="bold">{t('info.explanation.1')}</p>
                <p>{t('info.explanation.2')}</p>
                <p>{t('info.explanation.3')}</p>
              </div>
              <div className="column img-col">
                <img src={Collage} alt="" />
              </div>
            </div>
            <div className="rules-container">
              <h2>{t('info.rules')}</h2>
              <RuleSet.current />
            </div>
          </div>
        </div>
      </div>

      <div className={'container thanks ' + (showThanks ? '' : 'hidden')}>
        <div className="img-container">
          <img src={userImage} alt="" />
        </div>
        <div className="button-container">
          <div>
            <button
              onClick={() => setShowThanks(false)}
              className="button"
              disabled={uploaded}
            >
              {t('change')}
            </button>
          </div>
          <p>{t('share with people.tag')}</p>
          <div>
            <a
              onClick={() => submitForm()}
              className="button"
              href={userImage}
              download="meeldetuletus"
            >
              {t('download')}
            </a>
          </div>

          {uploaded && (
            <div className="notification">Page will reload shortly</div>
          )}
          <p>
            <span>{t('share with people.1')}</span>
            <span>{t('share with people.2')}</span>
          </p>
          <p>{t('make sure to share')}</p>
        </div>
      </div>
    </section>
  );
};

export default Register;
